"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TranscriptContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _TranscriptView = _interopRequireDefault(require("./TranscriptView/TranscriptView"));

var _transcriptCompiler = _interopRequireDefault(require("../../../utilities/transcriptLib/transcriptCompiler"));

var _sentencesBySpeaker = _interopRequireDefault(require("../../../utilities/transcriptLib/transcriptTransformers/sentencesBySpeaker"));

var _markIdentifiedRanges = _interopRequireDefault(require("../../../utilities/transcriptLib/transcriptTransformers/markIdentifiedRanges"));

var _Range = _interopRequireDefault(require("../../../utilities/transcriptLib/Range"));

var _Term = _interopRequireDefault(require("../../../utilities/transcriptLib/Term"));

var _constants = require("../../../utilities/transcriptLib/constants");

var _compareRangeLists = _interopRequireDefault(require("../../../utilities/transcriptLib/compareRangeLists"));

var _chunkSpeakers = _interopRequireDefault(require("../../../utilities/transcriptLib/transcriptTransformers/chunkSpeakers"));

var _ScrollerContext = _interopRequireDefault(require("../../ScrollerContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SINGLE_SPEAKER_COLOR = "black";

var TranscriptContext = /*#__PURE__*/_react["default"].createContext({
  transcript: [],
  transcriptBySpeaker: [],
  speakers: [],
  transcriptTimeRanges: [],
  identifiedRanges: [],
  identifiedRangeBrackets: []
});

exports.TranscriptContext = TranscriptContext;

var TranscriptContainer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TranscriptContainer, _Component);

  function TranscriptContainer(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = _this.propsToState();
    return _this;
  }

  var _proto = TranscriptContainer.prototype;

  _proto.identifiedRangeBrackets = function identifiedRangeBrackets(pProps) {
    var props = pProps || this.props;
    if (props.markedRanges.length) return props.markedRanges;
    return [];
  };

  _proto.getSpeakerColorsFromSpeakers = function getSpeakerColorsFromSpeakers(speakers) {
    var map = new Map([[_constants.DEFAULT_SPEAKER, SINGLE_SPEAKER_COLOR]]);
    if (!speakers || speakers.size < 2) return map;
    var index = 0;
    speakers.forEach(function (name) {
      map.set(name, _constants.SPEAKER_COLORS[index]);
      index += 1;
    });
    return map;
  };

  _proto.transcriptBySpeaker = function transcriptBySpeaker(pProps) {
    var props = pProps || this.props;
    var terms = (0, _transcriptCompiler["default"])(props.transcript);
    var bySpeaker = (0, _sentencesBySpeaker["default"])(terms);
    bySpeaker.value = (0, _chunkSpeakers["default"])(bySpeaker.value);
    var brackets = this.identifiedRangeBrackets(props);

    if (brackets) {
      (0, _markIdentifiedRanges["default"])(bySpeaker, brackets);
    }

    return bySpeaker;
  };

  _proto.transcriptTimeRanges = function transcriptTimeRanges(pProps) {
    var props = pProps || this.props;
    if (!props.transcript) return [];
    return (0, _lodash.map)(props.transcript.filter(function (t) {
      return t && t.s && t.e && !t.m;
    }), function (t) {
      return new _Range["default"]({
        name: t.p,
        start: t.s,
        end: t.e
      });
    });
  };

  _proto.getSpeakersFromTBS = function getSpeakersFromTBS(transcriptBySpeaker) {
    if (transcriptBySpeaker && transcriptBySpeaker instanceof _Term["default"]) {
      var speakers = transcriptBySpeaker.get("speakers");
      if (speakers && speakers instanceof Set) return Array.from(speakers.values());
    }

    return [_constants.DEFAULT_SPEAKER];
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {
    if (this.state.scrollHeight !== newState.scrollHeight) return true;
    if (newProps.transcript !== this.props.transcript) return true;
    if (!(0, _compareRangeLists["default"])(newState.transcriptTimeRanges, this.state.transcriptTimeRanges)) return true;
    if (!(0, _deepEqual["default"])(newProps.query, this.props.query)) return true;
    return !(0, _deepEqual["default"])(newProps.markedRanges, this.props.markedRanges);
  };

  _proto.getScrollerContextValue = function getScrollerContextValue() {
    var _this2 = this;

    var height = this.state.scrollHeight;
    return {
      scrollRef: this.state.scrollRef,
      setScrollRef: function setScrollRef(scrollRef) {
        _this2.setState({
          scrollRef: scrollRef,
          scrollHeight: (0, _lodash.get)(scrollRef, "clientHeight", height)
        });
      },
      scrollHeight: height
    };
  };

  _proto.propsToState = function propsToState(pProps) {
    var props = pProps || this.props;
    return {
      transcriptTimeRanges: this.transcriptTimeRanges(props),
      identifiedRanges: props.identifiedRanges
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate(newProps, newState) {
    var _this$propsToState = this.propsToState(newProps),
        transcriptTimeRanges = _this$propsToState.transcriptTimeRanges,
        identifiedRanges = _this$propsToState.identifiedRanges;
    /**
     * watching transcript values, not scroll height
     */


    if (!(0, _deepEqual["default"])(newState.identifiedRanges, identifiedRanges) || !(0, _compareRangeLists["default"])(newState.transcriptTimeRanges, transcriptTimeRanges)) {
      this.setState(this.propsToState(newProps));
    }
  };

  _proto.getTranscriptContextValue = function getTranscriptContextValue() {
    var transcriptsBySpeaker = this.transcriptBySpeaker();
    var speakers = this.getSpeakersFromTBS(transcriptsBySpeaker);
    var speakerColors = this.getSpeakerColorsFromSpeakers(speakers);
    var transcriptTimeRanges = this.transcriptTimeRanges();
    var identifiedRanges = this.props.identifiedRanges;
    var identifiedRangeBrackets = this.identifiedRangeBrackets();
    var isChatTextMedia = this.props.isChatTextMedia;
    var metadata = this.props.metadata; // @TODO: rename, as it is a post-processed version

    return {
      transcriptsBySpeaker: transcriptsBySpeaker,
      speakers: speakers,
      speakerColors: speakerColors,
      transcriptTimeRanges: transcriptTimeRanges,
      identifiedRanges: identifiedRanges,
      identifiedRangeBrackets: identifiedRangeBrackets,
      isChatTextMedia: isChatTextMedia,
      metadata: metadata
    };
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(TranscriptContext.Provider, {
      value: this.getTranscriptContextValue()
    }, /*#__PURE__*/_react["default"].createElement(_ScrollerContext["default"].Provider, {
      value: this.getScrollerContextValue()
    }, /*#__PURE__*/_react["default"].createElement(_TranscriptView["default"], this.props)));
  };

  return TranscriptContainer;
}(_react.Component);

TranscriptContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  // duration: PropTypes.number.isRequired,
  transcript: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    s: _propTypes["default"].number.isRequired,
    e: _propTypes["default"].number.isRequired,
    m: _propTypes["default"].string,
    w: _propTypes["default"].string,
    p: _propTypes["default"].number
  })).isRequired,
  identifiedRanges: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    startTime: _propTypes["default"].number,
    endTime: _propTypes["default"].number,
    startWord: _propTypes["default"].shape({
      p: _propTypes["default"].number,
      w: _propTypes["default"].string
    }),
    endWord: _propTypes["default"].shape({
      p: _propTypes["default"].number,
      w: _propTypes["default"].string
    })
  }))
} : {};
var _default = TranscriptContainer;
exports["default"] = _default;